module.exports = __webpack_public_path__ + "img/ok.7ed2e36.svg";